/**
 * @module Theme
 */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-option-layout-background-color-detail',
  templateUrl: './theme-option-layout-background-color-detail.component.html',
  styleUrls: ['./theme-option-layout-background-color-detail.component.css']
})
export class ThemeOptionLayoutBackgroundColorDetailComponent implements OnInit, OnDestroy {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() type: ChartType;

  color = ItemColor('themes');
  opacity: number;
  backgroundColor: string;
  changedOptions$sub: Subscription;
  optionType: ThemeOptionType = 'layout_backgroundColor';

  constructor() {}

  ngOnInit() {
    this.setAttributes();

    this.changedOptions$sub = this.themeOptions.changedOptions$.subscribe({
      next:(option: ThemeOptionType) => {
        if(option === this.optionType) {
          this.setAttributes();
        }
      }
    });
  }

  ngOnDestroy() {
    this.changedOptions$sub.unsubscribe();
  }

  setAttributes() {
    this.backgroundColor = this.themeOptions.options(this.type).layout['backgroundColor'].toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.options(this.type).layout['backgroundColor'].toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.backgroundColor = value;
    this.themeOptions.setOption(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), [this.type]);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) this.themeOptions.setOption(this.optionType, this.backgroundColor + Math.round(value * 255 / 100).toString(16), [this.type]);
    else this.themeOptions.setOption(this.optionType, this.backgroundColor + '00', [this.type]);
  }

}
